<template><!-- svgo-optimised -->
<svg class="icon icon__filter" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M4 6h4M20 6H10M8 3v6M4 12h12M20 12h-2M16 9v6M4 18h6M20 18h-8M10 15v6" stroke="#000"/></svg></template>